import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import CONFIG from "../config"
import {getToken,getRefreshToken,saveToken,destroyToken} from '../jwt'

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = CONFIG.API_URL;
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = 'Bearer ' + getToken();
    
    Vue.axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      const originalRequest = error.config
      const { status } = error.response;
      if (status === 401){
        if ( error.config.url != '/api/Systems/RefreshToken' &&
          error.response.headers['www-authenticate'].includes("The token lifetime is invalid")){
          originalRequest._retry = true
          axios.defaults.headers['Authorization'] = 'Bearer ' + getRefreshToken();
          Vue.axios.post("/api/Systems/RefreshToken").then((response) => {
            let token = response.data.Data.token
            let refresh_token = response.data.Data.refresh_token
            saveToken(token, refresh_token)
            axios.defaults.headers['Authorization'] = 'Bearer ' + token
            originalRequest.headers['Authorization'] = 'Bearer ' + token
            return axios(originalRequest)
          }).catch((error) => {
            destroyToken()
            window.location.href = '/login'
          })
          return;
        }
        
        if (!window.location.pathname.startsWith("/login")) {
          destroyToken()
          window.location.href = '/login'
        }
      }
      return Promise.reject(error);
    });
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource) {
    return Vue.axios.get(`${resource}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params, header={}) {
    return Vue.axios.post(`${resource}`, params, header);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;


// WEBPACK FOOTER //
// ./src/common/api/index.js